import { inject, Injectable } from '@angular/core';
import { ConsentForm, CreateProviderAppointmentResponse } from '@models';
import { catchError, Observable, of, switchMap } from 'rxjs';
import { CONSENT_FORMS_SERVICE } from '../tokens/consent-forms.token';
import { BookingIntentsService } from './booking-intents.service';
import { ConsentFormService } from './consent-forms/consent-form.service';

@Injectable({
  providedIn: 'root',
})
export class BookingIntentCompletionService {
  private readonly consentFormsService = inject(CONSENT_FORMS_SERVICE);
  private readonly consentFormService = inject(ConsentFormService);
  private readonly bookingIntentsService = inject(BookingIntentsService);

  signConsentAndConfirm(
    intentId: string
  ): Observable<CreateProviderAppointmentResponse | null> {
    return this.consentFormsService
      .getSubmissionsByBookingIntentId(intentId)
      .pipe(
        catchError(() => of<ConsentForm[]>([])),
        switchMap(submissions => {
          const pendingConsentFormsIds = (submissions ?? []).map(
            ({ id }) => id
          );

          return pendingConsentFormsIds.length
            ? this.consentFormService.openSignDialog(pendingConsentFormsIds)
            : of(true);
        }),
        switchMap(allSigned =>
          allSigned === true
            ? this.bookingIntentsService.confirmBookingIntent(intentId)
            : of(null)
        )
      );
  }
}
